import React, { useState } from "react";
import styles from "./BakeryScheduleLocationManagement.module.css";
import { Table } from "antd";
import { Dropdown, SubmitButton } from "../../../../../components";
import { MdOutlineModeEdit } from "react-icons/md";
import MultipleCheck from "../../../../../components/MultipleCheck/MultipleCheck";

const BakeryScheduleLocationManagement = ({
  isScheduleEditable,
  setisScheduleEditable,
}) => {
  const operationDaysOptions = [
    { id: 1, name: "Monday" },
    { id: 2, name: "Tuesday" },
    { id: 3, name: "Wednesday" },
    { id: 4, name: "Thursday" },
    { id: 5, name: "Friday" },
    { id: 6, name: "Saturday" },
    { id: 7, name: "Sunday" },
  ];

  const departmentTypes = [
    { id: 1, label: "Mixing", value: "MIXING" },
    { id: 2, label: "Packaging", value: "PACKAGING" },
    { id: 3, label: "Quality", value: "QUALITY" },
  ];

  const [department, setdepartment] = useState(departmentTypes[0]);

  const columns = [
    {
      title: "Department",
      dataIndex: "Department",
      key: "Department",
    },
    {
      title: "Opening Hours",
      dataIndex: "OpeningHours",
      key: "Opening Hours",
      render: (text) => (
        <div style={{ display: "flex", alignItems: "center", gap: "5px" }}>
          {text}
          {isScheduleEditable && (
            <div className={styles.EditIcon}>
              <MdOutlineModeEdit
                cursor={"pointer"}
                color="var(--white-color)"
                size={12}
              />
            </div>
          )}
        </div>
      ),
    },
    {
      title: "Closing Hours",
      dataIndex: "ClosingHours",
      key: "Closing Hours",
      render: (text) => (
        <div style={{ display: "flex", alignItems: "center", gap: "5px" }}>
          {text}
          {isScheduleEditable && (
            <div className={styles.EditIcon}>
              <MdOutlineModeEdit
                cursor={"pointer"}
                color="var(--white-color)"
                size={12}
              />
            </div>
          )}
        </div>
      ),
    },
    {
      title: "Break Hour(s)",
      key: "Break Hour(s)",
      dataIndex: "BreakHour",
      render: (text) => (
        <div style={{ display: "flex", alignItems: "center", gap: "5px" }}>
          {text}
          {isScheduleEditable && (
            <div className={styles.EditIcon}>
              <MdOutlineModeEdit
                cursor={"pointer"}
                color="var(--white-color)"
                size={12}
              />
            </div>
          )}
        </div>
      ),
    },
    {
      title: "Operation Days",
      key: "Operation Days",
      dataIndex: "OperationDays",
      render: (text) => (
        <div style={{ display: "flex", alignItems: "center", gap: "5px" }}>
          {isScheduleEditable ? (
            <MultipleCheck data={operationDaysOptions} displayCheckBox label={"Operation Days"} />
          ) : (
            <MultipleCheck data={operationDaysOptions} label={"Operation Days"}   />
          )}
        </div>
      ),
    },
  ];
  const data = [
    {
      Department: "Mixing Station",
      OpeningHours: "08:00 AM",
      ClosingHours: "10:00 PM",
      BreakHour: "01:00–02:00 PM",
      OperationDays: "Mon – Sat",
    },
    {
      Department: "Make-up Station",
      OpeningHours: "08:00 AM",
      ClosingHours: "10:00 PM",
      BreakHour: "01:00–02:00 PM",
      OperationDays: "Mon – Sat",
    },
    {
      Department: "Oven Station",
      OpeningHours: "08:00 AM",
      ClosingHours: "10:00 PM",
      BreakHour: "01:00–02:00 PM",
      OperationDays: "Mon – Sat",
    },
    {
      Department: "Proofing Station",
      OpeningHours: "08:00 AM",
      ClosingHours: "10:00 PM",
      BreakHour: "01:00–02:00 PM",
      OperationDays: "Mon – Sat",
    },
    {
      Department: "Chilling Station",
      OpeningHours: "08:00 AM",
      ClosingHours: "10:00 PM",
      BreakHour: "01:00–02:00 PM",
      OperationDays: "Mon – Sat",
    },

    {
      Department: "Assembly Station",
      OpeningHours: "08:00 AM",
      ClosingHours: "10:00 PM",
      BreakHour: "01:00–02:00 PM",
      OperationDays: "Mon – Sat",
    },
    {
      Department: "Packing Station",
      OpeningHours: "08:00 AM",
      ClosingHours: "10:00 PM",
      BreakHour: "01:00–02:00 PM",
      OperationDays: "Mon – Sat",
    },
  ];
  return (
    <div>
      <Table
        scroll={{ x: true }}
        columns={columns}
        dataSource={data}
        pagination={false}
      />
    </div>
  );
};

export default BakeryScheduleLocationManagement;
